import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { forkJoin } from 'rxjs';
import { UtilisateurService } from '../../services/utilisateur.service';
import { ReferentielService } from '../../services/referentiel.service';
import { Utilisateur } from '../../interfaces/utilisateur.interface';
import { ParametresProfil, ParametresCommune, ServiceItem } from '../../interfaces/referentiel.interface';
import { ParametresAgence } from '../../interfaces/agence.interface';

export interface UtilisateurDetailResolvedData {
  user: Utilisateur;
  formData: {
    profils: ParametresProfil[];
    services: ServiceItem[];
    agences: ParametresAgence[];
    communes: ParametresCommune[];
  };
}

export const utilisateurDetailResolver: ResolveFn<UtilisateurDetailResolvedData> = (route: ActivatedRouteSnapshot) => {
  const id = +route.paramMap.get('id')!;
  const utilisateurService = inject(UtilisateurService);
  const referentielService = inject(ReferentielService);
  return forkJoin({
    user: utilisateurService.getUtilisateurById(id),
    formData: referentielService.getFormData(),
  });
};
